/**
 * is object
 * @param  {*}       data any type
 * @return {boolean}
 */
__.isObject = function(data) {
  return Object.prototype.toString.call(data) === '[object Object]';
};
